'use strict';

var React = require('react');
require('@amzn/stencil-react-theme-default');
var context = require('@amzn/stencil-react-components/context');
var layout = require('@amzn/stencil-react-components/layout');
var text = require('@amzn/stencil-react-components/text');
var icons = require('@amzn/stencil-react-components/icons');
require('./SurgePremium-9eee1b19.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var QuickLink = function QuickLink(props) {
  var caption = props.caption,
      _props$external = props.external,
      external = _props$external === void 0 ? false : _props$external,
      innerContent = props.innerContent,
      onPress = props.onPress;
  return /*#__PURE__*/React__default["default"].createElement(QuickLinkButton, {
    onClick: onPress,
    role: 'link'
  }, /*#__PURE__*/React__default["default"].createElement(layout.Col, {
    alignItems: 'center',
    gridGap: 'S200'
  }, /*#__PURE__*/React__default["default"].createElement(IconContainer, {
    className: 'QuickLink_IconContainer'
  }, innerContent), /*#__PURE__*/React__default["default"].createElement(layout.Row, {
    alignItems: 'center',
    gridGap: 'S200'
  }, /*#__PURE__*/React__default["default"].createElement(text.Text, {
    fontSize: 'T200'
  }, caption), external && /*#__PURE__*/React__default["default"].createElement(icons.IconExternalLink, {
    size: icons.IconSize.ExtraSmall
  }))));
};

var IconContainer = context.styledWithTheme(layout.View)(function (_ref) {
  var theme = _ref.theme;
  return "\n        background: ".concat(theme.selectors.color('neutral05'), ";\n        color: ").concat(theme.selectors.color('primary70'), ";\n        border-radius: 50%;\n        padding: ").concat(theme.selectors.space('S300'), "px;\n        transition: color 250ms ease,\n            background-color 250ms ease;\n    ");
});
var QuickLinkButton = context.styledWithTheme('button')(function (_ref2) {
  var theme = _ref2.theme;
  return "\n        background-color: transparent;\n        border: none;\n\n        &:hover,\n        &:focus {\n            cursor: pointer;\n\n            .QuickLink_IconContainer {\n                background: ".concat(theme.selectors.color('primary70'), ";\n                color: ").concat(theme.selectors.color('neutral0'), ";\n            }\n        }\n    ");
});

exports.QuickLink = QuickLink;
//# sourceMappingURL=QuickLink-6e9c6884.js.map
